import { Injectable } from '@angular/core';
import { Router, Params } from '@angular/router';
import { CartProductInfo } from '../providers/cart-product-info.provider';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private router: Router) {}

  public goToCart(): void {
    this.router.navigate(['list', 'cart']);
  }

  private queryParams: Params;

  public storeQueryParams(queryParams: Params): void {
    this.queryParams = queryParams;
  }

  public goToList(productInfo: CartProductInfo): void {
    if (productInfo.widgetContext === 'list') {
      this.router.navigate(['list'], { queryParams: this.queryParams });
    }

    if (productInfo.widgetContext === 'main') {
      this.router.navigate(['id', productInfo.productIds[0]]);
    }
  }

  public goToNotFound(): void {
    this.router.navigate(['/not-found']);
  }
}
